import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

//etc
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordModule } from 'primeng/password';
//modules
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/dialog';

//components
import { CadastrarProfissionaisComponent } from './profissional/cadastrar-profissionais/cadastrar-profissionais.component';
import { ListaProfissionaisComponent } from './profissional/lista-profissionais/lista-profissionais.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { SliderModule } from 'primeng/slider';
import { CheckboxModule } from 'primeng/checkbox';

import { InputMaskModule } from 'primeng/inputmask';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TabViewModule } from 'primeng/tabview';
import { BadgeModule } from 'primeng/badge';
import { RadioButtonModule } from 'primeng/radiobutton';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';

import { InputNumberModule } from 'primeng/inputnumber';
import { KeyFilterModule } from 'primeng/keyfilter';
import { FileUploadModule } from 'primeng/fileupload';
//routing
import { CadastroRoutingModule } from './cadastro-routing.module';

// unidades
import { UnidadeListaComponent } from './unidades/unidade-lista/unidade-lista.component';

import { ModalAnexarComponent } from './profissional/modal-anexar/modal-anexar.component';
import { ModalContabilidadeComponent } from './profissional/modal-contabilidade/modal-contabilidade.component';
import { UnidadeFormComponent } from './unidades/unidade-form/unidade-form.component';
import { ExameListaComponent } from './exame/exame-lista/exame-lista.component';
import { ExameFormComponent } from './exame/exame-form/exame-form.component';
import { ProfissionalServicoFormComponent } from './profissional/profissional-servico-form/profissional-servico-form.component';
import { FuncionarioListaComponent } from './funcionario/funcionario-lista/funcionario-lista.component';
import { FuncionarioFormComponent } from './funcionario/funcionario-form/funcionario-form.component';
import { CondicionalListaComponent } from './condicional/condicional-lista/condicional-lista.component';
import { FormatPhoneNumberPipe } from 'src/app/shared/pipe/formatPhoneNumber/formatPhoneNumber';
import { FormatCNPJPipe } from 'src/app/shared/pipe/formatCNPJ/formatCNPJ';
import { InputTextModule } from 'primeng/inputtext';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [
    ListaProfissionaisComponent,
    UnidadeListaComponent,
    UnidadeFormComponent,
    ModalAnexarComponent,
    ExameListaComponent,
    ExameFormComponent,
    CadastrarProfissionaisComponent,
    ModalContabilidadeComponent,
    ProfissionalServicoFormComponent,
    FuncionarioListaComponent,
    FuncionarioFormComponent,
    CondicionalListaComponent,
    FormatPhoneNumberPipe,
    FormatCNPJPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    CadastroRoutingModule,
    DialogModule,
    DynamicDialogModule,
    DropdownModule,
    FormsModule,
    TooltipModule,
    InputMaskModule,
    RouterModule,
    SelectButtonModule,
    InputSwitchModule,
    TabViewModule,
    ProgressSpinnerModule,
    BadgeModule,
    MultiSelectModule,
    SliderModule,
    RadioButtonModule,
    CheckboxModule,
    AccordionModule,
    CalendarModule,
    InputNumberModule,
    KeyFilterModule,
    PasswordModule,
    FileUploadModule,
    InputTextModule,
    NgxMaskModule.forRoot()
  ],
  exports: [ListaProfissionaisComponent, UnidadeListaComponent],
  providers: [ListaProfissionaisComponent, DatePipe],
})
export class CadastroModule {}
